<template>
    <div>
        <desktop v-show="deviceStore.isDesktop" :data></desktop>
        <mobile v-show="deviceStore.isMobile" :data></mobile>
    </div>
</template>

<script setup>
import desktop from './desktop/index.vue';
import mobile from './mobile/index.vue';
import { usePageData } from '~/composables/usePageData';

// 使用 composable 加载首页数据（pagePath 为 false 表示首页）
const { data, deviceStore, initData } = usePageData({
    pagePath: false,
    enableKeepalive: false,
    logPrefix: '首页'
});

// 初始化数据
await initData();
</script>

<style lang="scss" scoped></style>